module.exports = __webpack_public_path__ + "static/smartSolvers-515df700c9153d7aee1d7e45783c0ed5.svg";